<template>
  <div class="body">
      <Headtow></Headtow>
      <div  id="bj">
        <div id="w-center">
          <div id="Breadcrumb">
            <i class="el-icon-house Breadcrumb-i" ></i>
            <el-breadcrumb separator-class="el-icon-arrow-right">
              <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
              <el-breadcrumb-item>会员中心</el-breadcrumb-item>
            </el-breadcrumb>
          </div>
          <!-- 左侧 -->
          <Memberleft></Memberleft>

          <!-- 左侧结束 -->
          <div class="w-products rihgt">
            <div class="Member-right">
                <p class="content-jj">我的积分</p>
            </div>
            <div class="h-20"></div>
            <div class="w-products rihgt Member-right">
              <div class="member-label">
                <el-tabs>
                  <el-tab-pane label="我的积分">
                    <div class="Integral-div">
                      当前账户积分：{{info.integral}}
                    </div>
                    <ul class="Integral-ul">
                      <p>请对公转款后联系客户进行积分充值</p>
                      <li>对公账户：{{info.dgzh}}</li>
                      <li>银行信息：{{info.yhxx}}</li>
                      <li>公司名称：{{info.gsmc}}</li>
                    </ul>

                      <el-button type="primary" class="btn-kf" size="medium" @click="$router.push('/Aboutlx?index=7&id=19')">联系客服</el-button>
                  </el-tab-pane>
                  <el-tab-pane label="积分明细">
                     <li class="forum-li"  v-for="(item, index) in list" :key="item.id">
                         <div class="Forum-wen Forum-wen-cz"><span>{{item.title}}<a>{{item.text}}</a></span><span>{{item.create_time}}</span></div>
                     </li>
                     <div class="page">
                       <el-pagination
                         background
                         layout="prev, pager, next"
                         :page-size="12"
                         @current-change="handleCurrentChange"
                         :total="total">
                       </el-pagination>
                     </div>
                  </el-tab-pane>
                </el-tabs>
              </div>
              <div class="h-30"></div>
              <div class="h-30 clear"></div>
              <div class="h-30"></div>
            </div>

          </div>

          <div class="clear"></div>


        </div>
      </div>
       <Foot></Foot>
  </div>

</template>

<script>
import headtow from '@/components/public/headtow.vue';
import foot from '@/components/public/foot.vue';
import memberleft from '@/components/public/memberleft.vue'
export default{
  data(){
    return {
     activeIndex: '3',
     page:1,
     total:0,
     info:{},
     list:{},
    }
  },
  components: {
    'Headtow': headtow,  //将别名demo 变成 组件 Demo
    'Foot': foot,
    'Memberleft': memberleft,

  },
  mounted () {
    this.recordapi();
  },
  methods:{
    recordapi(){
        var that = this;
        var userid = that.$cookieStore.getCookie('userid');
        that.$api.post("/Member/MemberIntegral",{'userid':userid,'page':this.page}).then(res => {
          console.log(res);
          if(res.code == 1){
            this.info = res.info;
            this.list = res.list.data;
            this.total = res.list.total
            this.loading = false
          }

        });
    },
    handleCurrentChange(val) {
      console.log(`当前页: ${val}`);
      this.page = val;
      this.recordapi();
    },
    // 分类
    handleSelect(key, keyPath) {
      console.log(key, keyPath);
    }

  }

 }
</script>



// WEBPACK FOOTER //
// src/components/MemberIntegral.vue